var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLockedBxsCricketBall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10820_26893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1658 3.38619C12.942 3.19405 12.7075 3.01479 12.4635 2.84928L12.4891 2.82364L12.1467 2.63953L12.0445 2.57205L12.0363 2.58013L11.8969 2.50518C10.5397 1.7753 8.98329 1.50236 7.45868 1.72684C5.93407 1.95131 4.52243 2.66125 3.43314 3.75134C2.34386 4.84143 1.63497 6.2536 1.41162 7.77837C1.18827 9.30315 1.46236 10.8593 2.19323 12.216L2.26025 12.3404L2.25337 12.3472L2.31898 12.4494L2.51541 12.8141L2.53887 12.7901C2.70285 13.0355 2.88339 13.2696 3.07925 13.4905L3.4316 13.8881L3.8071 13.5123L13.1938 4.11897L13.575 3.7375L13.1658 3.38619ZM14.8069 5.42174L14.7399 5.29734L14.7468 5.29058L14.6812 5.18832L14.4848 4.82369L14.4613 4.84764C14.2973 4.60221 14.1168 4.36819 13.9209 4.14722L13.5686 3.74968L13.1931 4.12545L3.80641 13.5188L3.42521 13.9002L3.83437 14.2516C4.05815 14.4437 4.29264 14.623 4.53672 14.7885L4.51108 14.8141L4.85343 14.9982L4.95569 15.0657L4.9639 15.0576L5.10328 15.1326C6.46052 15.8624 8.01688 16.1354 9.54149 15.9109C11.0661 15.6864 12.4777 14.9765 13.567 13.8864C14.6563 12.7963 15.3652 11.3842 15.5886 9.85938C15.8119 8.3346 15.5378 6.77845 14.8069 5.42174Z",
    fill: "#EDF7FF",
    stroke: "#979797"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10820_26893"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.814453)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedBxsCricketBall);
export default __webpack_public_path__ + "static/media/locked-bxs_cricket-ball.df63b81bb9eaa33e0ed0bfa5b01fa079.svg";
export { ForwardRef as ReactComponent };